export class SearchKeyword {
	static readonly $type: string = "SearchKeyword";
	readonly $type: string = SearchKeyword.$type;

	keyword: string = "";
	searchCount: number = 0;
	searchWeight: number = 0;
}
